import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'quorum-send-email-preview-dialog',
  templateUrl: './send-email-preview-dialog.component.html',
  styleUrls: ['./send-email-preview-dialog.component.scss'],
})
export class SendEmailPreviewDialogComponent implements OnInit {
  emailForm: FormGroup = new FormGroup({
    toEmails: new FormControl(null, Validators.required),
    subject: new FormControl(null, Validators.required),
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {},
    public dialogRef: MatDialogRef<SendEmailPreviewDialogComponent>
  ) {}

  ngOnInit(): void {}

  sendEmail(dialogRef: MatDialogRef<SendEmailPreviewDialogComponent>, emailForm: FormGroup) {
    dialogRef.close({ ...emailForm.value });
  }
}
